export function envConstant(key: string): string {
	return process.env[`REACT_APP_${key}`] || '';
}
